import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

export const initCategoriesSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".categories-slider__swiper",
  );

  sliders.forEach((el) => {
    // Guard: Prevent double initialization
    if (el.dataset.initialized === "true") return;
    el.dataset.initialized = "true";

    // Count the slides to determine if looping is safe.
    // The largest breakpoint sets slidesPerView to 4.
    // We need more than 4 slides to loop smoothly without duplicating issues.
    const slideCount = el.querySelectorAll(".swiper-slide").length;
    const enableLoop = slideCount > 4;

    new Swiper(el, {
      modules: [Pagination, Autoplay],
      // --- Performance Fixes ---
      observer: true,
      observeParents: true,
      // -------------------------
      slidesPerView: 2, // Mobile default (slides are larger)
      spaceBetween: 20,
      loop: enableLoop,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: { slidesPerView: 3 }, // Tablet
        1024: { slidesPerView: 4 }, // Desktop (Max 4 items = Larger slides)
      },
    });
  });
};
